import React from 'react';

interface LensIconProps {
  className?: string;
}

function LensIcon({ className }: LensIconProps) {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" width="20" height="22" fill="none">
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M9.375 17.5a8.125 8.125 0 100-16.25 8.125 8.125 0 000 16.25zm9.375 1.25l-2.938-2.938"
      ></path>
    </svg>
  );
}

export default LensIcon;
